import { createReducer } from 'redux-act';
import { StateStatus } from '@alycecom/utils';

import { TFullRecipient, TFullSender } from './users.types';
import { transformUsersData } from './users.helpers';
import { fetchUsers } from './users.actions';

export interface IUsersState {
  status: StateStatus;
  recipient: TFullRecipient | null;
  sender: TFullSender | null;
}

export const initialState: IUsersState = {
  status: StateStatus.Idle,
  recipient: null,
  sender: null,
};

export const users = createReducer<IUsersState>({}, initialState);

users
  .on(fetchUsers.pending, state => ({
    ...state,
    status: StateStatus.Pending,
  }))
  .on(fetchUsers.fulfilled, (state, payload) => ({
    ...state,
    status: StateStatus.Fulfilled,
    ...transformUsersData(payload),
  }))
  .on(fetchUsers.rejected, state => ({
    ...state,
    status: StateStatus.Rejected,
  }));
